import React from 'react';
import { getPeriodLabel } from '../../utils/helpers';

const StatRow = ({ label, count, max }) => {
  const pct = max > 0 ? (count / max) * 100 : 0;
  return (
    <div className="stat-row">
      <span className="stat-row-label">{label}</span>
      <div className="stat-row-bar">
        <div className="stat-row-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="stat-row-value">{count}</span>
    </div>
  );
};

const StatCard = ({ title, data }) => {
  if (!data || Object.keys(data).length === 0) return null;
  const max = Math.max(...Object.values(data));
  return (
    <div className="stat-card">
      <h3>{title}</h3>
      {Object.entries(data).map(([key, count]) => (
        <StatRow key={key} label={key} count={count} max={max} />
      ))}
    </div>
  );
};

const ContractsStats = ({ stats, selectedPeriod }) => {
  if (!stats) {
    return (
      <div className="stats">
        {[1, 2, 3].map(i => (
          <div key={i} className="skeleton-card">
            <div className="skeleton skeleton-line short" />
            <div className="skeleton skeleton-line number" style={{ marginBottom: '1rem' }} />
            <div className="skeleton skeleton-line long" />
            <div className="skeleton skeleton-line medium" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="stats">
      <div className="stat-card">
        <h3>Totale {getPeriodLabel(selectedPeriod)}</h3>
        <p className="stat-number">{stats.total}</p>
      </div>
      <StatCard title="Per Mandante" data={stats.byMandante} />
      <StatCard title="Per Categoria" data={stats.byCategoria} />
      <StatCard title="Per Rischio" data={stats.byRisk} />
    </div>
  );
};

export default ContractsStats;
